import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { environment } from '../../../../../environments/environment'

@Component({
    selector: 'app-payfast-payment-form',
    templateUrl: './payfast-payment-form.component.html',
    styleUrls: ['./payfast-payment-form.component.scss'],
})
export class PayfastPaymentFormComponent implements OnInit, OnChanges {
    @Input() paymentData: any
    payfast_url = environment.payfastUrl
    formDataArray: { key: string; value: any }[] = []

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.updateFormData()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['paymentData']) {
            this.updateFormData()
        }
    }

    private updateFormData(): void {
        if (this.paymentData && typeof this.paymentData === 'object') {
            this.formDataArray = Object.entries(this.paymentData).map(([key, value]) => ({
                key,
                value,
            }))
            this.cdr.detectChanges()
        }
    }

    submitForm(form: HTMLFormElement): void {
        // Use native form submission to navigate to PayFast
        form.submit()
    }
}
